import { eventBus } from '@/eventBus';

export default function(progressEvent) {
    eventBus.$emit('downloadProgress', {total: progressEvent.total, loaded: progressEvent.loaded});
}
